import { render, staticRenderFns } from "./InputCheckboxCpt.vue?vue&type=template&id=069fa834&scoped=true&"
import script from "./InputCheckboxCpt.vue?vue&type=script&lang=ts&"
export * from "./InputCheckboxCpt.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069fa834",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
